import { orderUpdateReportOptions } from 'constants/loanActionEditor';

export const selectReportsOptions = () => orderUpdateReportOptions;
